import { CATEGORY_DETAILS, STATION_DETAILS, SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyLicence/GRSLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatGRS = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let baseLandFixedStationInfo = [];
    let mobilePortableStationInfo = [];
    let otherDetails;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        baseLandFixedStationInfo = licenceDetails?.baseLandFixedStationInfo
            ?.map((value: any, index: number) => ({
                'area-of-operation': value?.areaOfOperation ?? '-',
                'call-sign': value?.callSign ?? '-',
                'location-of-station': value?.locationOfStationEGRooftop ?? '-',
                'station-name': value?.stationName ?? '-',
                'building-name': value?.stationAddress?.buildingName ?? '-',
                'postal-code': value?.stationAddress?.postalCode ?? '-',
                'street-name': value?.stationAddress?.streetName ?? '-',
                'block-house-no': value?.stationAddress?.blockNo ?? '-',
                unit: value?.stationAddress?.unit ?? '-',
                'floor-level': value?.stationAddress?.floor ?? '-',
                'latitude-degrees': value?.latitudeDegrees ?? '-',
                'latitude-minutes': value?.latitudeMinutes ?? '-',
                'latitude-seconds': value?.latitudeSeconds ?? '-',
                'longitude-degrees': value?.longitudeDegrees ?? '-',
                'longitude-minutes': value?.longitudeMinutes ?? '-',
                'longitude-seconds': value?.longitudeSeconds ?? '-',
                'building-height-m': value?.buildingHeightM ?? '-',
                'station-antenna-effective-height-m-above-ground-level': value?.stationAntennaEffectiveHeightMAboveGroundLevel ?? '-',
                'station-elevation-angle': value?.stationElevationAngle ?? '-',
                transportable: value?.transportable ?? '-',
                'radius-of-operation-km': value?.radiusOfOperationKm ?? '-',
                'vendor-name': value?.vendorName ?? '-',
                'vendor-licence-number': value?.vendorLicenceNumber ?? '-',
                'contact-person': value?.contactPerson ?? '-',
                'contact-number': value?.ContactNumber ?? '-',
                'do-you-have-an-address-for-the-vendor': value?.doYouHaveAnAddressForTheVendor ?? 'No',
                'vendor-building-name': value?.vendorAddress?.buildingName ?? '-',
                'vendor-postal-code': value?.vendorAddress?.postalCode ?? '-',
                'vendor-street-name': value?.vendorAddress?.streetName ?? '-',
                'vendor-block-house-no': value?.vendorAddress?.blockNo ?? '-',
                'vendor-unit': value?.vendorAddress?.unit ?? '-',
                'vendor-floor-level': value?.vendorAddress?.floor ?? '-',
                'manufacturer-transmitter': value?.manufacturerTransmitter ?? '-',
                'manufacturer-receiver': value?.manufacturerReceiver ?? '-',
                'model-transmitter': value?.modelTransmitter ?? '-',
                'model-receiver': value?.modelReceiver ?? '-',
                'output-power-w-transmitter': value?.outputPowerWTransmitter ?? '-',
                'antenna-manufacturer': value?.antennaManufacturer ?? '-',
                polarization: value?.polarization ?? '-',
                'antenna-effective-height-m-above-ground-level': value?.antennaEffectiveHeightMAboveGroundLevel ?? '-',
                'antenna-elevation-angle': value?.northLatitudeDisplacement ?? '-',
                'north-latitude-displacement': value?.northLatitudeDisplacement ?? '-',
                'east-longitude-displacement': value?.eastLongitudeDisplacement ?? '-',
                'gain-db': value?.gainDB ?? '-',
                'filter-manufacturer': value?.filterManufacturer ?? '-',
                model: value?.model ?? '-',
                'insertion-loss-db': value?.insertionLossDB ?? '-',
                'tuned-frequency-mhz': value?.tunedFrequencyMHz ?? '-',
                'feeder-information': value?.feederInformation ?? '-',
                'feeder-line-type-transmit': value?.feederLineTypeTransmit ?? '-',
                'feeder-line-type-receive': value?.feederLineTypeReceive ?? '-',
                'feeder-line-length-m-transmit': value?.feederLineLengthMTransmit ?? '-',
                'feeder-line-length-m-receive': value?.feederLineLengthMReceive ?? '-',
                'feeder-line-loss-db-transmit': value?.feederLineLossDBTransmit ?? '-',
                'feeder-line-loss-db-receive': value?.feederLineLossDBReceive ?? '-',
                'frequency-and-emission-class-information':
                    value?.frequencyAndEmissionClassInformation.map((i: any) => {
                        return {
                            'desired-frequency-mhz-from-tx': i.desiredFrequencyMHzFromTransmit ?? '-',
                            'desired-frequency-mhz-to-tx': i.desiredFrequencyMHzToTransmit ?? '-',
                            'desired-frequency-mhz-from-rx': i.desiredFrequencyMHzFromReceive ?? '-',
                            'desired-frequency-mhz-to-rx': i.desiredFrequencyMHzToReceive ?? '-',
                            'desired-bandwidth-khz-tx': i.bandwidthKHzTransmit ?? '-',
                            'desired-bandwidth-khz-rx': i.bandwidthKHzReceive ?? '-',

                            'assigned-frequency-mhz-from-tx': i.assignedFrequencyMHzFromTransmit ?? '-',
                            'assigned-frequency-mhz-to-tx': i.assignedFrequencyMHzToTransmit ?? '-',
                            'assigned-frequency-mhz-from-rx': i.assignedFrequencyMHzFromReceive ?? '-',
                            'assigned-frequency-mhz-to-rx': i.assignedFrequencyMHzToReceive ?? '-',
                            'assigned-bandwidth-khz-tx': i.AssignedBandwidthTx ?? '-',
                            'assigned-bandwidth-khz-rx': i.AssignedBandwidthRx ?? '-',

                            'start-time': i.startTime ?? '-',
                            'stop-time': i.stopTime ?? '-',

                            'emission-class': i.emissionClass ?? '-',
                            'output-power-req': i.Power ?? '-',
                            power: i.Power ?? '-',
                            'power-unit': i.PowerUnit ?? '-'
                        };
                    }) ?? '-'
            }))
            .map((item: any, index: number) => {
                if (index === 0) {
                    return item;
                }
                return {
                    [`area-of-operation-${index}`]: item['area-of-operation'],
                    [`call-sign-${index}`]: item['call-sign'],
                    [`location-of-station-${index}`]: item['location-of-station'],
                    [`station-name-${index}`]: item['station-name'],
                    [`building-name-${index}`]: item['building-name'],
                    [`postal-code-${index}`]: item['postal-code'],
                    [`street-name-${index}`]: item['street-name'],
                    [`block-house-no-${index}`]: item['block-house-no'],
                    [`unit-${index}`]: item['unit'],
                    [`floor-level-${index}`]: item['floor-level'],
                    [`latitude-degrees-${index}`]: item['latitude-degrees'],
                    [`latitude-minutes-${index}`]: item['latitude-minutes'],
                    [`latitude-seconds-${index}`]: item['latitude-seconds'],
                    [`longitude-degrees-${index}`]: item['longitude-degrees'],
                    [`longitude-minutes-${index}`]: item['longitude-minutes'],
                    [`longitude-seconds-${index}`]: item['longitude-seconds'],
                    [`building-height-m-${index}`]: item['building-height-m'],
                    [`station-antenna-effective-height-m-above-ground-level-${index}`]:
                        item['station-antenna-effective-height-m-above-ground-level'],
                    [`station-elevation-angle-${index}`]: item['station-elevation-angle'],
                    [`transportable-${index}`]: item['transportable'],
                    [`radius-of-operation-km-${index}`]: item['radius-of-operation-km'],
                    [`vendor-name-${index}`]: item['vendor-name'],
                    [`vendor-licence-number-${index}`]: item['vendor-licence-number'],
                    [`contact-person-${index}`]: item['contact-person'],
                    [`contact-number-${index}`]: item['contact-number'],
                    [`do-you-have-an-address-for-the-vendor-${index}`]: item['do-you-have-an-address-for-the-vendor'],
                    [`vendor-building-name-${index}`]: item['vendor-building-name'],
                    [`vendor-postal-code-${index}`]: item['vendor-postal-code'],
                    [`vendor-street-name-${index}`]: item['vendor-street-name'],
                    [`vendor-block-house-no-${index}`]: item['vendor-block-house-no'],
                    [`vendor-unit-${index}`]: item['vendor-unit'],
                    [`vendor-floor-level-${index}`]: item['vendor-floor-level'],
                    [`manufacturer-transmitter-${index}`]: item['manufacturer-transmitter'],
                    [`manufacturer-receiver-${index}`]: item['manufacturer-receiver'],
                    [`model-transmitter-${index}`]: item['model-transmitter'],
                    [`model-receiver-${index}`]: item['model-receiver'],
                    [`output-power-w-transmitter-${index}`]: item['output-power-w-transmitter'],
                    [`antenna-manufacturer-${index}`]: item['antenna-manufacturer'],
                    [`polarization-${index}`]: item['polarization'],
                    [`antenna-effective-height-m-above-ground-level-${index}`]: item['antenna-effective-height-m-above-ground-level'],
                    [`antenna-elevation-angle-${index}`]: item['antenna-elevation-angle'],
                    [`north-latitude-displacement-${index}`]: item['north-latitude-displacement'],
                    [`east-longitude-displacement-${index}`]: item['east-longitude-displacement'],
                    [`gain-db-${index}`]: item['gain-db'],
                    [`filter-manufacturer-${index}`]: item['filter-manufacturer'],
                    [`model-${index}`]: item['model'],
                    [`insertion-loss-db-${index}`]: item['insertion-loss-db'],
                    [`tuned-frequency-mhz-${index}`]: item['tuned-frequency-mhz'],
                    [`feeder-information-${index}`]: item['feeder-information'],
                    [`feeder-line-type-transmit-${index}`]: item['feeder-line-type-transmit'],
                    [`feeder-line-type-receive-${index}`]: item['feeder-line-type-receive'],
                    [`feeder-line-length-m-transmit-${index}`]: item['feeder-line-length-m-transmit'],
                    [`feeder-line-loss-db-transmit-${index}`]: item['feeder-line-loss-db-transmit'],
                    [`feeder-line-loss-db-receive-${index}`]: item['feeder-line-loss-db-receive'],
                    [`frequency-and-emission-class-information-${index}`]: item['frequency-and-emission-class-information']
                };
            });
    }

    if (licenceDetails && licenceDetails.mobilePortableStationInfo && licenceDetails.mobilePortableStationInfo.length > 0) {
        mobilePortableStationInfo = licenceDetails?.mobilePortableStationInfo
            ?.map((value: any, index: number) => ({
                'area-of-operation': value?.areaOfOperation ?? '-',
                'call-sign': value?.callSign ?? '-',
                'location-of-station': value?.locationOfStationEGRooftop ?? '-',
                'station-name': value?.stationName ?? '-',
                'building-name': value?.address?.buildingName ?? '-',
                'postal-code': value?.address?.postalCode ?? '-',
                'street-name': value?.address?.streetName ?? '-',
                'block-house-no': value?.address?.blockNo ?? '-',
                unit: value?.address?.unit ?? '-',
                'floor-level': value?.address?.floor ?? '-',
                'latitude-degrees': value?.latitudeDegrees ?? '-',
                'latitude-minutes': value?.latitudeMinutes ?? '-',
                'latitude-seconds': value?.latitudeSeconds ?? '-',
                'longitude-degrees': value?.longitudeDegrees ?? '-',
                'longitude-minutes': value?.longitudeMinutes ?? '-',
                'longitude-seconds': value?.longitudeSeconds ?? '-',
                'radius-of-operation-km': value?.radiusOfOperationKm ?? '-',
                'area-of-operation-line-1': value?.areaOfOperationLine1 ?? '-',
                'area-of-operation-line-2': value?.areaOfOperationLine2 ?? '-',
                'area-of-operation-line-3': value?.areaOfOperationLine3 ?? '-',
                'no-of-mobiles': value?.noOfMobiles ?? '-',
                'mobile-communication-with': value?.mobileCommunicationWith ?? '-',
                'coverage-information': value?.coverageInformation ?? '-',
                'manufacturer-transmitter': value?.manufacturerTransmitter ?? '-',
                'manufacturer-receiver': value?.manufacturerReceiver ?? '-',
                'model-transmitter': value?.modelTransmitter ?? '-',
                'model-receiver': value?.modelReceiver ?? '-',
                'output-power-w-transmitter': value?.outputPowerWTransmitter ?? '-',
                'mobile-station-frequency-info':
                    value?.mobileStationFrequencyInfo.map((i: any, index: any) => {
                        return {
                            'id-no': index + 1,
                            'desired-frequency-mhz-from-tx': i.desiredFrequencyMHzFromTransmit ?? '-',
                            'desired-frequency-mhz-to-tx': i.desiredFrequencyMHzToTransmit ?? '-',
                            'desired-frequency-mhz-from-rx': i.desiredFrequencyMHzFromReceive ?? '-',
                            'desired-frequency-mhz-to-rx': i.desiredFrequencyMHzToReceive ?? '-',
                            'desired-bandwidth-khz-tx': i.bandwidthKHzTransmit ?? '-',
                            'desired-bandwidth-khz-rx': i.bandwidthKHzReceive ?? '-',

                            'assigned-frequency-mhz-from-tx': i.assignedFrequencyMHzFromTransmit ?? '-',
                            'assigned-frequency-mhz-to-tx': i.assignedFrequencyMHzToTransmit ?? '-',
                            'assigned-frequency-mhz-from-rx': i.assignedFrequencyMHzFromReceive ?? '-',
                            'assigned-frequency-mhz-to-rx': i.assignedFrequencyMHzToReceive ?? '-',
                            'assigned-bandwidth-khz-tx': i.AssignedBandwidthRx ?? '-',
                            'assigned-bandwidth-khz-rx': i.AssignedBandwidthTx ?? '-',

                            'emission-class-tx': i.emissionClassTransmit ?? '-',
                            'emission-class-rx': i.emissionClassReceive ?? '-',

                            'start-time': i.startTime ?? '-',
                            'stop-time': i.stopTime ?? '-',

                            power: i.Power ?? '-',
                            'power-unit': i.PowerUnit ?? '-'
                        };
                    }) ?? '-'
            }))
            .map((item: any, index: number) => {
                if (index === 0) {
                    return item;
                }
                return {
                    [`area-of-operation-${index}`]: item['area-of-operation'],
                    [`call-sign-${index}`]: item['call-sign'],
                    [`location-of-station-${index}`]: item['location-of-station'],
                    [`station-name-${index}`]: item['station-name'],
                    [`building-name-${index}`]: item['building-name'],
                    [`postal-code-${index}`]: item['postal-code'],
                    [`street-name-${index}`]: item['street-name'],
                    [`block-house-no-${index}`]: item['block-house-no'],
                    [`unit-${index}`]: item['unit'],
                    [`floor-level-${index}`]: item['floor-level'],
                    [`latitude-degrees-${index}`]: item['latitude-degrees'],
                    [`latitude-minutes-${index}`]: item['latitude-minutes'],
                    [`latitude-seconds-${index}`]: item['latitude-seconds'],
                    [`longitude-degrees-${index}`]: item['longitude-degrees'],
                    [`longitude-minutes-${index}`]: item['longitude-minutes'],
                    [`longitude-seconds-${index}`]: item['longitude-seconds'],
                    [`radius-of-operation-km-${index}`]: item['radius-of-operation-km'],
                    [`area-of-operation-line-1-${index}`]: item['area-of-operation-line-1'],
                    [`area-of-operation-line-2-${index}`]: item['area-of-operation-line-2'],
                    [`area-of-operation-line-3-${index}`]: item['area-of-operation-line-3'],
                    [`no-of-mobiles-${index}`]: item['no-of-mobiles'],
                    [`mobile-communication-with-${index}`]: item['mobile-communication-with'],
                    [`coverage-information-${index}`]: item['coverage-information'],
                    [`manufacturer-transmitter-${index}`]: item['manufacturer-transmitter'],
                    [`manufacturer-receiver-${index}`]: item['manufacturer-receiver'],
                    [`model-transmitter-${index}`]: item['model-transmitter'],
                    [`model-receiver-${index}`]: item['model-receiver'],
                    [`output-power-w-transmitter-${index}`]: item['output-power-w-transmitter'],
                    [`mobile-station-frequency-info-${index}`]: item['mobile-station-frequency-info']
                };
            });
    }

    if (licenceDetails && licenceDetails.otherDetails) {
        otherDetails = licenceDetails.otherDetails;
    }

    licence = {
        id: 'general-radio-com',
        formID: 'general-radio-com',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${CATEGORY_DETAILS}-licence-category`]: licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '',

            [`${STATION_DETAILS}-station-tabs`]: [
                { 'fixed-station-licence': [...baseLandFixedStationInfo] },
                { 'mobile-station-licence': [...mobilePortableStationInfo] }
            ],
            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const grsPayload = {
    formatGRS
};

export default grsPayload;
